module.exports = __webpack_public_path__ + "static/media/dog-small.65b9bba4.svg";